import type { IconSvgObject } from './types';

const ScrollIcon: IconSvgObject = [
  ["path", { d: "M11 6.00879H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 10H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 14H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19 22C20.1046 22 21 21.1046 21 20V4C21 2.89543 20.1046 2 19 2H9C7.89543 2 7 2.89543 7 4V18M19 22C17.8954 22 17 21.1046 17 20V18H3V20C3 21.1046 3.89543 22 5 22H19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ScrollIcon;
